import { StartMigration, StartStatusDetection, CancelMigration, ResetStatusDetection, SetStatus, SetProgress } from './store/actions/migrate.actions';
import { OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MigrateService } from './core/migrate.service';
import { Subscription } from 'rxjs';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { Store } from '@ngrx/store';
import { getStatus, getProgress } from './store/selectors/migrate.selectors';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';
import { IAppState } from 'app/IAppState';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'biz-migrate-stakeholders',
  templateUrl: './migrate-stakeholders.component.html',
  styleUrls: ['./migrate-stakeholders.component.scss']
})
export class MigrateStakeholdersComponent implements OnInit {

  public isLoading = false;
  public progress: any;
  public status: string = 'NotStarted';
  private listTimeOut: any[] = [];
  private _toastSubscription: Subscription;
  private _statusSubscription: Subscription;
  private _progressSubscription: Subscription;

  constructor(private _store: Store<IAppState>,
    private _translateService: TranslateService,
    private _i18nService: I18nService,
    private _toastService: BzgToastService,
    private _showToastService: ShowToastService) {}

  ngOnInit() {
    this._store.dispatch(new StartStatusDetection());
    this._statusSubscription = this._store.select(getStatus).subscribe((status) => {
      if (status) {
        switch (status) {
          case "InProgress":
            this.status = status;
            this.isLoading = true;
            this.listTimeOut.push(setTimeout(() => {
              this._store.dispatch(new ResetStatusDetection());
              this._store.dispatch(new StartStatusDetection());
            }, 1000));
            break;
          case "Done":
            if (this.status !== 'NotStarted' && !this.checkStarted()) {
              this.status = status;
              this._showToastService.showToast(this._i18nService.instant('MIGRATE_STAKEHOLDERS.MESSAGE_TOAST_SUCCESS'), 'success');
            }
            this.isLoading = false;
            break;
          case "Error":
            this.status = status;
            this._showToastService.showToast(this._i18nService.instant('MIGRATE_STAKEHOLDERS.MESSAGE_TOAST_ERROR'), 'error');
            this.isLoading = false;
            break;
          default:
            this.status = status;
            this.isLoading = false;
            break;
        }
      }
    });

    this._progressSubscription = this._store.select(getProgress).subscribe((progress) => {
      if ((this.checkStarted() && progress.totalUsersToProcess > 0) ||
      this.status === 'InProgress' || this.status === 'Done' || this.status === 'Error') {
        this.progress = progress;
      }
    });
  }

  ngOnDestroy() {
    if (this._statusSubscription) {
      this._statusSubscription.unsubscribe();
    }
    if (this._progressSubscription) {
      this._progressSubscription.unsubscribe();
    }
    if (this._toastSubscription) {
      this._toastSubscription.unsubscribe();
    }
    this.listTimeOut.forEach(timeOut => clearTimeout(timeOut));
    this.status = this.status === 'Done' ? 'StartedDone' : this.status;
    this.status = this.status === 'Error' ? 'StartedError' : this.status;
    this.status = this.status === 'Canceled' ? 'StartedCanceled' : this.status;
    this._store.dispatch(new SetStatus(this.status));
    this._store.dispatch(new SetProgress(this.progress));
  }

  public checkStarted() {
    return this.status === 'StartedDone' || this.status === 'StartedError' || this.status === 'StartedCanceled';
  }

  public startMigrate() {
    this.isLoading = true;
    this.initializeProgressBar();
    this._store.dispatch(new ResetStatusDetection());
    this._store.dispatch(new StartMigration());
  }

  public cancelMigrate() {
    this.isLoading = false;
    this.status = 'Canceled';
    this._store.dispatch(new CancelMigration());
    this.listTimeOut.forEach(timeOut => clearTimeout(timeOut));
  }

  private initializeProgressBar() {
    this.progress = {
      currentBatch: 0,
      currentPercentage: 0,
      totalBatches: 0,
      totalUsersProcessed: 0,
      totalUsersProcessing: 0,
      totalUsersToProcess: 0
    };
  }

}
